module.exports = __webpack_public_path__ + "static/media/SBDC.58fb07b0.png";